import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ShoppingCart, Trash2 } from 'lucide-react';
import { useFavorites } from '../../context/PortalContext';
import { useCart } from '../../context/CartContext';
import { ProductThumb } from '../../components/product/ProductThumb';
import { toast } from 'sonner';

export default function FavoritesPage() {
  const { favorites, removeFavorite } = useFavorites();
  const { addItem } = useCart();

  return (
    <div data-testid="favorites-page">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="text-2xl font-semibold tracking-tight mb-2">Articoli preferiti</h1>
        <p className="text-muted-foreground text-sm mb-6">{favorites.length} articoli salvati</p>

        {favorites.length === 0 ? (
          <div className="rounded-xl border bg-white p-12 text-center">
            <Star className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-semibold mb-2">Nessun preferito</h3>
            <p className="text-sm text-muted-foreground mb-4">Aggiungi prodotti ai preferiti dalle pagine del catalogo.</p>
            <Link to="/prodotti/toner" className="h-9 px-4 rounded-lg bg-[hsl(214,58%,41%)] text-white text-sm font-medium inline-flex items-center">Vai al catalogo</Link>
          </div>
        ) : (
          <div className="rounded-xl border bg-white overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b bg-[hsl(var(--dtk-canvas))]">
                  <th className="text-left px-4 py-3 text-xs font-semibold text-muted-foreground uppercase w-12"></th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-muted-foreground uppercase">Codice</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-muted-foreground uppercase">Prodotto</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-muted-foreground uppercase hidden sm:table-cell">Marca</th>
                  <th className="text-right px-4 py-3 text-xs font-semibold text-muted-foreground uppercase w-40"></th>
                </tr>
              </thead>
              <tbody>
                {favorites.map(p => (
                  <tr key={p.sku} className="border-b last:border-b-0 hover:bg-secondary/40 transition-colors">
                    <td className="px-4 py-2"><ProductThumb sku={p.sku} brand={p.brand} color={p.color} size="sm" /></td>
                    <td className="px-4 py-2"><Link to={`/prodotti/${p.category}/${p.sku}`} className="font-mono font-medium text-[hsl(214,58%,41%)] hover:underline">{p.sku}</Link></td>
                    <td className="px-4 py-2">{p.title}</td>
                    <td className="px-4 py-2 hidden sm:table-cell"><span className="text-xs px-2 py-0.5 rounded-md border bg-secondary/60 font-medium">{p.brand}</span></td>
                    <td className="px-4 py-2 text-right">
                      <div className="flex items-center justify-end gap-2">
                        <button onClick={() => { if (addItem(p) > 0) toast.success(`${p.sku} aggiunto al carrello`); }} className="h-7 px-2.5 rounded-md bg-[hsl(214,58%,41%)] text-white text-[10px] font-medium flex items-center gap-1 hover:bg-[hsl(214,58%,46%)]">
                          <ShoppingCart className="w-3 h-3" /> Carrello
                        </button>
                        <button onClick={() => removeFavorite(p.sku)} className="w-7 h-7 rounded flex items-center justify-center text-muted-foreground hover:text-red-500 hover:bg-red-50 transition-colors">
                          <Trash2 className="w-3.5 h-3.5" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
